import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconSize } from '@freelancer/ui/icon';
@Component({
  selector: 'fl-modal-error',
  template: `
    <div class="ModalError" [attr.data-edge-to-edge]="edgeToEdge">
      <h3 class="ModalError-title" i18n="Modal load error title">
        Aw, snap!
      </h3>

      <p class="ModalError-description" i18n="Modal load error description">
        Something went wrong while fetching the content. Please check your
        Internet connectivity and then retry.
      </p>

      <div class="ModalError-content">
        <button class="ModalError-toggleBtn" (click)="toggleError()">
          <ng-container
            *ngIf="!isErrorDisplayed"
            i18n="Modal load error details show more link"
          >
            Show more information
          </ng-container>
          <ng-container
            *ngIf="isErrorDisplayed"
            i18n="Modal load error details hide more link"
          >
            Hide more information
          </ng-container>
          <fl-icon
            class="ModalError-toggleBtn-icon"
            [name]="'ui-dropdown-arrow'"
            [size]="IconSize.SMALL"
            (click)="toggleError()"
          ></fl-icon>
        </button>

        <p class="ModalError-content-details" *ngIf="isErrorDisplayed">
          {{ errorMessage }}
        </p>
      </div>

      <div class="ModalError-actions">
        <button
          class="ModalError-retryBtn"
          i18n="Modal load error retry button"
          (click)="handleRetryClick()"
        >
          Retry
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./modal-error.component.scss'],
})
export class ModalErrorComponent {
  IconSize = IconSize;

  @Input() edgeToEdge = false;
  @Input() errorMessage: string;

  @Output() retry = new EventEmitter<void>();

  isErrorDisplayed = false;

  handleRetryClick() {
    this.retry.emit();
  }

  toggleError() {
    this.isErrorDisplayed = !this.isErrorDisplayed;
  }
}
